import { Injectable } from '@angular/core';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';
import { MessengerService } from '../messenger/messenger.service';

@Injectable()
export class CredentialsService extends RestfulService<any> {

  constructor(private restService: RestService, private ms: MessengerService) {
    super();
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('credentials');
  }

  public get(profileId, params: any = []): Promise<any> {
    params['type'] = 'email_password';
    return this.ms.get('credentials', profileId, params);
  }
}
